import { useEffect, useState } from "react";

export const ReadingProgress = ({ targetRef }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const update = () => {
      const el = targetRef.current;
      if (!el) return;
      const total = el.offsetHeight - window.innerHeight;
      const done = -el.getBoundingClientRect().top;
      setProgress(total > 0 ? Math.min(1, Math.max(0, done / total)) : 1);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [targetRef]);
  return (
    <div className="fixed top-0 inset-x-0 h-[3px] z-[60] pointer-events-none" aria-hidden="true" data-testid="reading-progress">
      <div className="h-full bg-primary origin-left" style={{ transform: `scaleX(${progress})` }} data-testid="reading-progress-bar" />
    </div>
  );
};
